import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BoardHeroVideoPanelComponent } from './board-hero-video-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [BoardHeroVideoPanelComponent],
  exports: [BoardHeroVideoPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class BoardHeroVideoPanelModule { }
